"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.batchResourceOperationFactory = void 0;
const tslib_1 = require("tslib");
const errors = tslib_1.__importStar(require("balena-errors"));
const chunk = require("lodash/chunk");
const _1 = require(".");
const CHUNK_SIZE = 200;
function batchResourceOperationFactory({ getAll, NotFoundError, AmbiguousResourceError, }) {
    function batchResourceOperation({ uuidOrIdOrIds, options, groupByNavigationPoperty, fn, }) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (Array.isArray(uuidOrIdOrIds) &&
                (!uuidOrIdOrIds.length ||
                    uuidOrIdOrIds.some((id) => typeof id !== 'number'))) {
                throw new errors.BalenaInvalidParameterError('uuidOrIdOrIds', uuidOrIdOrIds);
            }
            // create a list of UUIDs or chunks of IDs
            const chunks = typeof uuidOrIdOrIds === 'string'
                ? [uuidOrIdOrIds]
                : chunk(!Array.isArray(uuidOrIdOrIds) ? [uuidOrIdOrIds] : uuidOrIdOrIds, CHUNK_SIZE);
            const items = [];
            for (const uuidOrIdOrIdsChunk of chunks) {
                const resourceFilter = Array.isArray(uuidOrIdOrIdsChunk)
                    ? {
                        id: { $in: uuidOrIdOrIdsChunk },
                    }
                    : {
                        uuid: { $startswith: uuidOrIdOrIdsChunk },
                    };
                const combinedOptions = (0, _1.mergePineOptions)({
                    $select: [
                        'id',
                        ...(groupByNavigationPoperty ? [groupByNavigationPoperty] : []),
                    ],
                    $filter: resourceFilter,
                }, options);
                items.push(...(yield getAll(combinedOptions)));
            }
            const resourceIds = items.map((item) => item.id);
            if (!resourceIds.length) {
                throw new NotFoundError(uuidOrIdOrIds.toString());
            }
            const itemsByAccosiactedResource = groupByNavigationPoperty
                ? (0, _1.groupByMap)(items, (item) => item[groupByNavigationPoperty].__id)
                : new Map([[undefined, items]]);
            if (typeof uuidOrIdOrIds === 'string' && resourceIds.length > 1) {
                throw new AmbiguousResourceError(uuidOrIdOrIds);
            }
            else if (Array.isArray(uuidOrIdOrIds)) {
                const resourceIdsSet = new Set(resourceIds);
                for (const id of uuidOrIdOrIds) {
                    if (!resourceIdsSet.has(id)) {
                        throw new NotFoundError(id);
                    }
                }
            }
            for (const [associatedResourceId, associatedItems,] of itemsByAccosiactedResource.entries()) {
                for (const chunkedAssociatedItems of chunk(associatedItems, CHUNK_SIZE)) {
                    yield fn(chunkedAssociatedItems, associatedResourceId);
                }
            }
        });
    }
    return batchResourceOperation;
}
exports.batchResourceOperationFactory = batchResourceOperationFactory;
